import type { Drawer } from '@mui/material';
import { ToggleButton } from '@mui/material';
import { PLAN_STATUSES } from '@weft/types';
import type { PlanStatus } from '@weft/types';
import { values, withDefault } from '@weft/utils';
import React from 'react';
import type { ComponentProps } from 'react';
import { FilterDrawer } from '../../../../components/design/filter-drawer/FilterDrawer';
import { usePageParam } from '../../../../hooks/search-params/use-page-param';
import { usePlansOverviewsStatusesParam } from './hooks/use-plans-overviews-statuses-param';

export const PlansOverviewsFilterDrawer: React.FC<ComponentProps<typeof Drawer>> = (props) => {
  const [selectedPlansOverviewsStatuses, setSelectedPlansOverviewsStatuses] = usePlansOverviewsStatusesParam();
  const [_page, setPage] = usePageParam();

  const handlePlanOverviewStatusFiltersChange = (planStatus: PlanStatus) => {
    if (selectedPlansOverviewsStatuses?.includes(planStatus)) {
      setSelectedPlansOverviewsStatuses(selectedPlansOverviewsStatuses.filter((status) => status !== planStatus));
    } else {
      const currentSelectedPlanOverviewStatuses = withDefault(selectedPlansOverviewsStatuses, []);
      setSelectedPlansOverviewsStatuses([...currentSelectedPlanOverviewStatuses, planStatus]);
    }

    setPage(0);
  };

  return (
    <FilterDrawer {...props}>
      <FilterDrawer.Section label="Plan Status">
        <div className="flex flex-wrap gap-2">
          {
            values(PLAN_STATUSES).map(planStatus => (
              <ToggleButton
                key={crypto.randomUUID()}
                value={planStatus}
                className="border-style text-style rounded px-4 py-2 text-base font-normal"
                sx={{
                  textTransform: 'none',
                }}
                selected={selectedPlansOverviewsStatuses?.includes(planStatus)}
                onChange={() => handlePlanOverviewStatusFiltersChange(planStatus)}
              >
                {planStatus}
              </ToggleButton>
            ))
          }
        </div>
      </FilterDrawer.Section>
    </FilterDrawer>
  );
};